<template>
    <PanelItem :field="field" :index="index">
        <template #value>
            <span v-if="formattedValue">{{ formattedValue }}</span>
            <span v-else>&mdash;</span>
            <div v-if="showSpelledOut && spelledOutValue" class="mt-1 text-sm text-gray-500">
                {{ spelledOutValue }}
            </div>
        </template>
    </PanelItem>
</template>

<script>
export default {
    props: ['resource', 'resourceName', 'resourceId', 'field', 'index'],

    computed: {
        locale() {
            return this.field.locale || 'en'
        },

        currency() {
            return this.field.currency || 'USD'
        },

        showSpelledOut() {
            return this.field.showSpelledOut === true
        },

        formattingOptions() {
            return this.field.formattingOptions || {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }
        },

        formattedValue() {
            const value = this.field.value

            if (value === null || value === undefined || value === '') {
                return null
            }

            try {
                const num = parseFloat(value)
                if (isNaN(num)) return value.toString()

                const formatter = new Intl.NumberFormat(this.locale, {
                    style: 'currency',
                    currency: this.currency,
                    ...this.formattingOptions,
                })

                return formatter.format(num)
            } catch (e) {
                return value.toString()
            }
        },

        spelledOutValue() {
            if (!this.showSpelledOut || !this.formattedValue) return null

            try {
                const value = parseFloat(this.field.value)
                if (isNaN(value)) return null

                const formatter = new Intl.NumberFormat(this.locale, {
                    style: 'currency',
                    currency: this.currency,
                    currencyDisplay: 'name',
                    ...this.formattingOptions,
                })

                return formatter.format(value)
            } catch (e) {
                return null
            }
        },
    },
}
</script>

